export default {
  occupation: 'Ocupación',
  occupationplaceholder: 'Ocupación, profesión u oficio'
}
